/**
 * Const to indicate if the service is free
 */
export const FREE = 0;

/**
 * Const to indicate if the service is with payment
 */
export const PAYMENT = 1;